import { useTranslation } from 'react-i18next';

export default function CTABanner() {
  const { t } = useTranslation();

  const bannerImage = `https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20arrangement%20with%20sneakers%20hoodie%20leather%20bag%20watch%20and%20cap%20on%20warm%20cream%20linen%20surface%2C%20minimal%20editorial%20style%2C%20soft%20natural%20morning%20light%2C%20clean%20fashion%20composition%2C%20warm%20neutral%20background%2C%20elevated%20lifestyle%20photography&width=1200&height=600&seq=banner-v2-unique-h9i0&orientation=landscape`;

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        {/* Image */}
        <div className="rounded-2xl overflow-hidden mb-10 max-w-3xl mx-auto">
          <img
            src={bannerImage}
            alt="CSSBuy Spreadsheet produtos em destaque"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        {/* Text */}
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug mb-4">
          {t('cta_banner.line1')}
          <br />
          <span className="italic font-normal text-foreground-600">{t('cta_banner.line2')}</span>
          <br />
          {t('cta_banner.line3')}
        </h2>

        {/* Button */}
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap inline-flex items-center justify-center px-10 py-4 bg-foreground-950 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors cursor-pointer mt-8"
        >
          {t('cta_banner.button')}
          <i className="ri-arrow-right-up-line ml-2 w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}